import { Injectable } from '@angular/core';
import { AuthService } from '../features/auth/services/auth.service';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, Route, CanLoad } from '@angular/router';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})

export class AdminGaurd implements CanActivate, CanLoad {

  redirectUrl = '/selectapp';
  loginUrl = '/auth/login';
  userRoles = ['admin', 'anglotechadmin', 'thometechadmin', 'demoanalyticsadmin'];

  constructor(private readonly authService: AuthService,
              private readonly router: Router) { }

  canLoad(route: Route): boolean {
    const userType = localStorage.getItem('userrole');
    
    if (this.authService.isLoggedIn() && this.userRoles.includes(userType)) {
      console.log('log check ',userType);
      return true;
    }
    this.authService.setRedirectUrl(route.path);
    this.router.navigate(['/auth/login']);
    return false;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean { 
    if (state.url.includes('/voting')) {
      return true;
    }
  
    const userType = localStorage.getItem('userrole');
  
    if (this.authService.isLoggedIn()) {
      console.log('log check 2', userType);
      if (this.userRoles.includes(userType)) {
        return true;
      }
    }
   
    this.authService.setRedirectUrl(state.url);
    this.router.navigate(['/auth/login']);
    return false;
  }
  
}

